import React from "react";
import "./BlogCardComponent.css";
import { useNavigate } from "react-router-dom";
import { environment } from "../../environments/environments";

const truncateHtmlContent = (htmlContent, limit) => {
  if (!htmlContent) return "";
  const textContent = htmlContent
    .replace(/<\/?[^>]+(>|$)/g, "")
    .replace(/&[^;]+;/g, "")
    .trim();
  return textContent.length > limit
    ? textContent.slice(0, limit) + "..."
    : textContent;
};

const BlogCardComponent = ({ item, index, setIndex }) => {
  const navigate = useNavigate();
  const imageUrl = `${environment?.url}/uploads/blogs/${item?.image}`;
  const previewText = truncateHtmlContent(item?.desc, 100);

  const handleClick = () => {
    if (setIndex) {
      setIndex(index);
    } else {
      navigate("/BlogDetailsScreen", { state: { data: item, index } });
    }
  };

  return (
    <div className="blog-cardcomponent" onClick={handleClick}>
      <div className="leftcomponent">
        <img src={imageUrl} alt="blog" className="blog-imagecomponent" />
      </div>
      <div className="rightcomponent">
        <h3 className="blog-titlecomponent">{item?.title}</h3>
        <div className="preview-textdiv">
          <p className="preview-textcomponent">{previewText}</p>
        </div>
        <div className="read-more-containercomponent">
          <span className="read-more-textcomponent">Read More</span>
        </div>
      </div>
    </div>
  );
};

export default BlogCardComponent;
